import React from 'react';
import styles from "../styles/Main.module.css";

const Main = () => {
  return (
    <div className={styles.main_container}>
      <section className={styles.hero}>
        <div className={styles.hero_content}>
          <h2>제조·헬스케어·도시·에너지</h2>
          <h2>산업을 혁신하는 AI 솔루션</h2>
        </div>
      </section>
    </div>
  )
}

export default Main